package de.oevbs.kunde.kundenportal2.services.digiservicecard

import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.layouts.card
import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.Pages
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.carContractsButtonToggleFormat
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.model.services.contract.CarContract
import de.oevbs.kunde.kundenportal2.model.services.digiservicecard.*
import de.oevbs.kunde.kundenportal2.navigation.visit
import de.oevbs.kunde.kundenportal2.services.digiservicecard.store.DigitalServiceCardStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.invoke
import dev.fritz2.headless.validation.Severity
import kotlinx.coroutines.flow.combine

fun RenderContext.digitalServiceCardStart() {

    val dscStore = DigitalServiceCardStore(job)

    headerImageLayout {
        title("Digitale Kfz-Servicekarte anfordern")
        content {
            renderDigiCard(dscStore)
        }
    }
}

private fun RenderContext.renderDigiCard(dscStore: DigitalServiceCardStore) {

    dscStore.currentStep.render { step ->

        GlobalServiceMessagesStore.clear()

        when (step) {
            GeneralProgressStep.SUBMIT1 -> digiCardStep1(dscStore)
            GeneralProgressStep.SUCCESS2 -> {
                val selectedContractSub = dscStore.map(DigitalServiceCardInit.selectedContract())
                messagePagePre(
                    header = "Erfolgreich angefordert",
                    severity = Severity.Success,
                    preContent = PortalContactNotes.DigitalServiceCardSent(
                        selectedContractSub.current?.contractNumberPm ?: "",
                        selectedContractSub.current?.licencePlate ?: ""
                    ).note
                )
            }
        }
    }
}

fun RenderContext.digiCardStep1(dscStore: DigitalServiceCardStore) {
    contentContainer {
        dscStore.init()
        globalInitTracker.data.combine(dscStore.initFailedFlow, ::Pair).render { (loading, failed) ->
            if (loading) return@render
            when {
                failed -> noContractDataFoundMessage()
                else -> showUi(dscStore)
            }
        }
    }
}

fun RenderContext.showUi(dscStore: DigitalServiceCardStore) {

    val selectedContractSub = dscStore.map(DigitalServiceCardInit.selectedContract())
    val contractsSub = dscStore.map(DigitalServiceCardInit.contracts())

    contractsSub.data.render contractsList@{ contracts ->
        if (contracts.isEmpty()) {
            messageCardWithContent(
                "Sie haben kein Fahrzeug bei uns versichert. Möchten Sie das ändern? Melden Sie sich bei Ihrer Beraterin oder Ihrem Berater."
            ) {
                btn {
                    label("Mitteilung schreiben")
                }.clicks handledBy { Pages.contactMessage.visit() }
            }
            return@contractsList
        }

        paragraph {
            +"Mit der digitalen Kfz-Servicekarte bieten wir Ihnen eine einfache und unkomplizierte Möglichkeit, die"
            +" wichtigsten Informationen zu Ihrer Kraftfahrzeugversicherung auf dem Smartphone bereit zu haben. So"
            +" können Sie im Schadenfall schnell alle wichtigen Vertrags- und Kontaktdaten "
            +" mit den Unfallbeteiligten teilen. Weitere Informationen finden Sie unter "
            inlineLink(
                text = "www.oeffentliche.de/servicekarte",
                link = "http://www.oeffentliche.de/servicekarte",
            )
            +"."
        }

        sectionHeader("Vertrag auswählen")

        card {
            buttonToggleKupo<CarContract?> {
                value.single(selectedContractSub)
                options = contractsSub.current
                optionsFormat = carContractsButtonToggleFormat
            }
        }

        selectedContractSub.data.combine(
            dscStore.map(DigitalServiceCardInit.mail()).data, ::Pair
        ).render { (selectedContract, mail) ->
            if (selectedContract != null) {
                card {
                    +"Den Download-Link für Ihre digitale Servicekarte zum Fahrzeug "
                    br {}
                    b {
                        +"${selectedContract.branchGroup}, ${selectedContract.licencePlate} (${selectedContract.contractNumberPm})"
                    }
                    br {}
                    +" erhalten Sie per Mail an Ihre in den Vertragsdaten hinterlegte Mailadresse "
                    b { +mail }
                    +"."
                }
            }
        }

        paragraph {
            +"Für die Erstellung der digitalen Kfz-Servicekarte ist die Verarbeitung Ihrer Vertragsdaten notwendig. Mit"
            +" der Anforderung der Karte stimmen Sie dieser Verarbeitung zu."
            br {}
            +"Darüber hinaus können Sie Ihre Einwilligung zur digitalen Informationszusendung per Push-Mitteilung"
            +" an Ihr Smartphone erteilen (optional)."
        }

        val checkLabel =
            """Ich bin einverstanden, künftig von meinem Vermittler und den Unternehmen der Öffentlichen Versicherung
                | Braunschweig zu relevanten Themen rund um Produkte und Services informiert zu werden. Ich kann mich
                | jederzeit gegen diesen Informationsservice entscheiden. Dies kann ich über die Einstellungen für
                | Push-Mitteilungen auf meinem Smartphone und in der Wallet-App sowie über das Entfernen der digitalen
                | Kfz-Servicekarte von meinem Smartphone vornehmen.
             """.trimMargin()

        card {
            checkboxSingle {
                value(dscStore.map(DigitalServiceCardInit.allowPushNotifications()))
                label {
                    +checkLabel
                }
            }
        }

        buttonContainer {
            btn {
                label("Download-Link anfordern")
                busy(globalSubmitTracker.data)
            }.clicks handledBy dscStore.requestDigiCard
        }
    }
}